/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Admin_Users_Dialogs_Delete_DescriptionInputs */

const es_admin_users_dialogs_delete_description = /** @type {(inputs: Admin_Users_Dialogs_Delete_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El usuario "${i?.email}" será eliminado permanentemente. Esta acción no se puede deshacer y se perderá toda su información.`)
};

const en_admin_users_dialogs_delete_description = /** @type {(inputs: Admin_Users_Dialogs_Delete_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The user "${i?.email}" will be permanently deleted. This action cannot be undone and all associated data will be lost.`)
};

/**
* | output |
* | --- |
* | "The user \"{email}\" will be permanently deleted. This action cannot be undone and all associated data will be lost." |
*
* @param {Admin_Users_Dialogs_Delete_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_users_dialogs_delete_description = /** @type {((inputs: Admin_Users_Dialogs_Delete_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Dialogs_Delete_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_users_dialogs_delete_description(inputs)
	return en_admin_users_dialogs_delete_description(inputs)
});
export { admin_users_dialogs_delete_description as "admin.users.dialogs.delete.description" }